import { Button } from '@/components/Common';
import { Modal } from '@/components/Layout';
import { useUnlinkGiftsFromExamConfig } from '@/api/hooks/useExamConfig';
import { useToast } from '@/hooks/useToast';

type GiftDeletionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  examConfigId: string;
  giftId: string;
};

const GiftDeletionModal = ({
  isOpen,
  onClose,
  examConfigId,
  giftId,
}: GiftDeletionModalProps) => {
  const { mutate: unlinkGiftsFromExamConfig, isPending } =
    useUnlinkGiftsFromExamConfig();
  const { showToast } = useToast();

  const handleDeleteGift = () => {
    unlinkGiftsFromExamConfig(
      {
        examConfigId,
        giftIds: [giftId],
      },
      {
        onSuccess: () => {
          showToast('Cadeau supprimé avec succès', 'success');
          onClose();
        },
        onError: (error) => {
          showToast(error.message, 'error');
        },
      },
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalStyle="bg-carbon min-w-[23.4375rem]"
      headerStyle="bg-carbon"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          Supprimer le cadeau
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          Êtes-vous sûr de vouloir supprimer ce cadeau ?
        </p>
        <div className="flex justify-between items-center gap-6 mt-4">
          <Button
            onClick={onClose}
            title="Annuler"
            className="!bg-completed hover:!outline-completed hover:!text-completed
              hover:!bg-hoverColor text-white !px-16"
          />
          <Button
            className="!px-16"
            title={isPending ? 'Suppression en cours...' : 'Supprimer'}
            onClick={handleDeleteGift}
          />
        </div>
      </div>
    </Modal>
  );
};

export default GiftDeletionModal;
